import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=5bebe5a6&scoped=true"
import script from "./ImageComponent.vue?vue&type=script&lang=js"
export * from "./ImageComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&id=5bebe5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebe5a6",
  null
  
)

export default component.exports